/**
 * Message status constants
 * Centralized definitions for all message status values used throughout the application
 */
export const MESSAGE_STATUS = {
  NEW: 'new',
  READ: 'read',
  VIEWED: 'viewed',
  DELETED: 'deleted',
  DELETED_BY_RECIPIENT: 'deleted by recipient',
  DELETED_BY_SENDER: 'deleted by sender',
  REPLIED: 'replied',
} as const;

export type MessageStatus = typeof MESSAGE_STATUS[keyof typeof MESSAGE_STATUS];

/**
 * Special sender names
 */
export const SPECIAL_SENDER = {
  SYSTEM_PROCESS: 'system process',
} as const;

export type SpecialSender = typeof SPECIAL_SENDER[keyof typeof SPECIAL_SENDER];

/**
 * CSS class names for message statuses
 */
export const MESSAGE_STATUS_CLASS = {
  NEW: 'message-status status-new',
  READ: 'message-status status-read',
  VIEWED: 'message-status status-viewed',
  DELETED: 'message-status status-deleted',
  DELETED_BY_RECIPIENT: 'message-status status-recipient-deleted',
  DELETED_BY_SENDER: 'message-status status-sender-deleted',
  REPLIED: 'message-status status-replied',
  DEFAULT: 'message-status status-default',
} as const;
